import { Column, ModelBase } from 'loca-boot-core'

/**
 * 首页搜索列表
 */
export class SearchListItemModel extends ModelBase {
  @Column()
  public name!: string

  @Column()
  public addr!: string

  @Column()
  public location!: string

  @Column()
  public address!: string

  @Column()
  public id!: string

  @Column()
  public type!: string

  @Column()
  public pointType!: string

  @Column()
  public pointSubType!: string
}
/**
 * 首页搜索列表
 */
export class SearchListModel extends ModelBase {
  @Column({ name: 'poi', childType: SearchListItemModel })
  public suggestsPois!: SearchListItemModel[]

  @Column({ name: 'nio_store', childType: SearchListItemModel })
  public suggestsNioStore!: SearchListItemModel[]

  @Column({ name: 'test_drive', childType: SearchListItemModel })
  public suggestsTestDrive!: SearchListItemModel[]

  @Column({ name: 'service_center', childType: SearchListItemModel })
  public suggestsServiceCenter!: SearchListItemModel[]

  @Column({ name: 'recharge', childType: SearchListItemModel })
  public suggestsRecharge!: SearchListItemModel[]

  @Column({ name: 'recharge|ps', childType: SearchListItemModel })
  public suggestsRechargePS!: SearchListItemModel[]

  @Column({ name: 'recharge|cs', childType: SearchListItemModel })
  public suggestsRechargeCS!: SearchListItemModel[]
}

/**
 * 首页搜索列表
 */
export class SearchModel extends ModelBase {
  @Column({ name: 'search_results' })
  public searchResults!: SearchListModel
}
